import { resolverValor } from './parser.js'
import { ejecutarFuncion } from './ejecutarFuncion.js'

export function ejecutarExpresion(expresion, datos) {
  const contenido = expresion.replace(/^\$\{|\}$/g, '').trim()

  // VARIABLES v:
  if (contenido.startsWith('v:')) {
    return resolverValor(datos, contenido.substring(2))
  }

  // IMÁGENES i: → se procesan en la capa 4
  if (contenido.startsWith('i:')) {
    return expresion
  }

  // FUNCIONES
  if (contenido.includes(':')) {
    const [nombreFuncion, ...resto] = contenido.split(':')
    const argumentosCrudos = resto.join(':')
    return ejecutarFuncion(nombreFuncion, argumentosCrudos, datos)
  }

  // LITERAL
  return contenido
}